import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import '../../assets/stylesheets/Game2.scss';
import Game2Step1 from './Game2Step1';
import Game2Step2 from './Game2Step2';
import Game2Step3 from './Game2Step3';
import Game2Step4 from './Game2Step4';
import Game2Step5 from './Game2Step5';
import Modal from 'react-modal';

@inject('AuthStore', 'SchoolStore', 'Game2Store','Navigator')
@observer
export default class Game2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            navButtonLabels: [
                "Students’ Levels",
                "Situation Introduction",
                "Start Game",
                "Next Question",
                "Continue Lesson"
            ],
            gameSteps: [
                <Game2Step1/>,
                <Game2Step2/>,
                <Game2Step3/>,
                <Game2Step4/>,
                <Game2Step5/>
            ]
        };

        // Prevent unnecessary render
        this.teamAnswer = null;
    }

    componentDidMount() {
        this.props.Game2Store.loadQuestions();
        this.props.Game2Store.setPlayers(2);
    }

    handleNextStep() {

        if (this.teamAnswer) {

            const player = this.props.Game2Store.players.find(p => p.name === this.teamAnswer.player.name);
            var points = this.props.Game2Store.answers[this.teamAnswer.index].points;

            if( this.props.Game2Store.extraPoints == true && points == 10) {
                player.score += this.props.Game2Store.bonusPoint;
                this.props.Game2Store.extraPoints = false;
            } else {
                player.score += points;
            }

            if( points == 0) {
                this.props.Game2Store.extraPoints = true;
            }

            this.teamAnswer = null;
            this._setWinners();
        }

        if (this.state.step === 5) {
            this.props.Navigator.push("/games");
            return;
        }

        if (this.state.step === 4
            && !(this.props.Game2Store.round === (this.props.Game2Store.numberRounds * this.props.Game2Store.players.length))) {

            this.props.Game2Store.round += 1;
            return;
        }

        this.setState(
            prevState => {
                return {
                    step: prevState.step + 1
                }
            }
        )
    }

    _setWinners() {
        const playerOrdered = this.props.Game2Store.players.sort((a, b) => {
            return a.score < b.score;
        });

        let winners = [];
        let highScore = playerOrdered[0].score; // Gets the high score
        let loser;

        // Discover tie winners
        for (let w of playerOrdered) {
            if (w.score === highScore) {
                winners = [...winners, w];
            } else {
                loser = w;
            }
        }

        this.props.Game2Store.loser = loser;
        this.props.Game2Store.winners = winners;
    }

    handleChangeAnswer({player, index}) {
        this.teamAnswer = {player, index};
    }

    handleClose() {
        this.props.Navigator.push("/games")
    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    render() {

        const {
            step,
            gameSteps,
            navButtonLabels,
        } = this.state;

        const {
            players
        } = this.props.Game2Store;

        let cantGoNextStep = false;
        if (step === 2) {
            cantGoNextStep = players.find(p => p.levels.length === 0);
        }

        if (step === 4) {
            cantGoNextStep = true;
        }

        const customStyles = {
            overlay : {
                position          : 'fixed',
                top               : 0,
                left              : 0,
                right             : 0,
                bottom            : 0,
                backgroundColor   : 'black'
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                background            : 'black',
                color                 : 'white'
            }
        };

        return (
            <div className="Game2 Page">
                <Modal
                    isOpen={this.state.modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    <h1>Would you like to leave the game?</h1>
                    <button className="btn-modal"
                        onClick={this.handleClose.bind(this)}>YES
                    </button>
                    <button className="btn-modal right"
                        onClick={this.closeModal.bind(this)}>NO
                    </button>
                </Modal>
                <div className="Close">
                    <button className="btn-close"
                        onClick={this.openModal.bind(this)}>X
                    </button>
                </div>
                {step !== 4
                    ? gameSteps[step - 1]
                    : <Game2Step4 onChangeAnswer={this.handleChangeAnswer.bind(this)}/>
                }
                <div className="nav">
                    <button
                        className={"btn-nav-next" + ((step === 2 && players.length === 0) || cantGoNextStep ?  " disabled": "")}
                        onClick={this.handleNextStep.bind(this)}>{navButtonLabels[step - 1]}</button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/Game2/Game2.js